import React from 'react'
import t from 'prop-types'

const SectionContainer = ({ as, children, className, ...args }) => {
  const Tag = as
  return (
    <Tag
      className={`my-20 md:my-40 first:mt-0 last:mb-0 ${className || ''}`}
      {...args}
    >
      {children}
    </Tag>
  )
}

SectionContainer.propTypes = {
  as: t.string,
  children: t.element.isRequired,
}

SectionContainer.defaultProps = {
  as: 'section',
}

export default SectionContainer
